export default __webpack_public_path__ + "static/media/office-cleaning.a1787d14.jpeg";